// extracted by mini-css-extract-plugin
export var container = "_a2-1";
export var cornerButtonContainer = "_a2-6";
export var disabled = "_a2-2";
export var dragActive = "_a2-3";
export var fileContainer = "_a2-5";
export var hiddenInput = "_a2-4";
export var widthContainer = "_a2-0";